import React, { useEffect } from 'react'

import { Card } from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'
import styled from 'styled-components'

import SidebarFrame from 'components/SidebarFrame'
import { Bodytext, Heading } from 'components/typography'
import { directToMobileScreenViewed } from 'pages/redirect-to-mobile/events'
import theme from 'theme'
import {
  REDIRECT_TO_MOBILE_BODY,
  REDIRECT_TO_MOBILE_HEADER,
} from 'utils/testing/testIDs'

import AcornsGreen from '../../../assets/logos/acorns-green.svg'
import LockedNav from '../spend-locked-account/lockedNav'

const StyledCard = styled(Card)`
  width: 100%;
  max-width: 420px;
  padding: 40px;
  margin: 12% auto auto;

  @media (max-width: ${theme.breakpoints.md}px) {
    margin: 10% auto auto;
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: 5% auto auto;
    max-width: 335px;
    height: 461px;
  }
`

const CardImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 0px auto 20px;

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: auto;
  }
`

const CardMessage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin-top: 3%;
  }
`

const CardHeader = styled(Heading)`
  margin-bottom: 8px;
  text-align: center;
`

const CardBody = styled(Bodytext)`
  max-width: 300px;
  height: 38px;
  text-align: center;
  color: ${theme.colors.slate};
  margin: 0 auto 20px;

  @media (max-width: ${theme.breakpoints.sm}px) {
    max-width: 275px;
  }
`

const renderNav = () => {
  return <LockedNav />
}

const RedirectToMobile = (): JSX.Element => {
  const analytics = useAnalyticsClient()

  useEffect(() => {
    analytics.track('Screen Viewed', directToMobileScreenViewed)
  }, [])

  return (
    <SidebarFrame renderNav={renderNav}>
      <StyledCard>
        <CardMessage>
          <CardImage alt="locked-account-image" src={AcornsGreen} />
          <CardHeader data-testid={REDIRECT_TO_MOBILE_HEADER}>
            Hello There!
          </CardHeader>
          <CardBody data-testid={REDIRECT_TO_MOBILE_BODY}>
            Please login via your mobile app for the latest Acorns experience!
          </CardBody>
        </CardMessage>
      </StyledCard>
    </SidebarFrame>
  )
}

export default RedirectToMobile
